import { Component, OnInit, Input } from '@angular/core';
import { WinService } from 'src/app/services/win.service';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {

	@Input() imgIcon: string = '-2';
	@Input() bg: string = 'bg-light-grey';


	constructor(
		public winService: WinService
	) { }

	ngOnInit() {
	}

	get iconNo(){
		if(window.outerWidth <= 767){
			return '';
		} else {
			return this.imgIcon;
		}
	}

	get bgColor(){
		if(window.outerWidth <= 767){
			return 'bg-yellow';
		} else {
			return this.bg;
		}
	}

	get textColor(){
		if(window.outerWidth <= 767){
			return '';
		} else {
			if(this.bg == 'bg-white'){
				return ' fc-black-imp';
			} else {
				return '';
			}
		}
	}

}
